/**
 * Copy a list and sort it alphabetically by a text field.
 *
 * @template T
 * @param {Array<T>|null|undefined} items Rows to sort. A missing list is treated as empty.
 * @param {string} key Property whose string value sets the order.
 * @returns {Array<T>}
 */
export function sortAlphabetically(items, key) {
  const list = Array.isArray(items) ? [...items] : [];
  return list.sort((a, b) =>
    String(a?.[key] || "").localeCompare(String(b?.[key] || ""))
  );
}

/**
 * Copy a list, replace the row with the same id, and sort alphabetically.
 *
 * @template T
 * @param {Array<T>|null|undefined} items Current rows.
 * @param {T} item Row that includes `id`.
 * @param {string} key Property whose string value sets the order.
 * @returns {Array<T>}
 */
export function upsertAlphabetically(items, item, key) {
  const list = Array.isArray(items) ? items : [];
  const withoutMatch = list.filter(
    (row) => String(row?.id) !== String(item?.id)
  );
  return sortAlphabetically([...withoutMatch, item], key);
}
